import { createApi } from '@core/fetch'

/**
 * 任务中心相关接口
 */
export default {
  // http://autotest.hunliji.com/#/home/project/api?projectId=-701335349&moduleid=3675
  getTaskPageDetail: createApi(
    '/p/wedding/index.php/Admin/APIMerchantTaskDetail/MerchantInfo'
  )
}
